/**
 * Fixed wallet-deposit rungs (in cents), mirrored from
 * apps/api/src/services/deposit-ladder.ts. Every suggested deposit snaps up to
 * the smallest rung that covers the requested amount, so $25 is the
 * effective minimum.
 */
export const DEPOSIT_LADDER_CENTS = [2_500, 5_000, 10_000, 25_000, 50_000, 100_000] as const;

export const DEPOSIT_LADDER_MIN_CENTS = DEPOSIT_LADDER_CENTS[0];
export const DEPOSIT_LADDER_MAX_CENTS = DEPOSIT_LADDER_CENTS[DEPOSIT_LADDER_CENTS.length - 1];

/**
 * Returns the smallest ladder rung that is >= `amountCents`. When
 * `amountCents` exceeds the top rung, it is returned unchanged (never
 * clamped down) so long as it is a whole-dollar amount.
 */
export function snapDepositToLadder(amountCents: number): number {
  for (const rung of DEPOSIT_LADDER_CENTS) {
    if (amountCents <= rung) return rung;
  }
  return amountCents;
}
